import { render, staticRenderFns } from "./DialogPhieuChiTiet.vue?vue&type=template&id=16094cc8"
import script from "./DialogPhieuChiTiet.vue?vue&type=script&lang=js"
export * from "./DialogPhieuChiTiet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports